window.addEventListener("unhandledrejection", (e) => {
  e.preventDefault();
  console.warn(e.reason);
}, false);

import { render } from 'solid-js/web'
import './index.css'
import account from '@/store/account'
import App from './App.jsx'
import Login from './Login.jsx'

import dayjs from "dayjs"
import UTC from 'dayjs/plugin/utc'
import Timezone from 'dayjs/plugin/timezone'
import LocalizedFormat from "dayjs/plugin/localizedFormat"
dayjs.extend(UTC)
dayjs.extend(Timezone)
dayjs.extend(LocalizedFormat)

const root = document.getElementById('root')

if (account().username) {
  render(() => <App />, root)
} else {
  render(() => <Login />, root)
}
